// Pure helpers for the public Special Events listing.
// Kept free of React so they can be unit tested (see eventFilters.test.js).
import moment from "moment";

export const DATE_RANGE_OPTIONS = [
  { value: "all", label: "All upcoming" },
  { value: "7", label: "Next 7 days" },
  { value: "30", label: "Next 30 days" },
  { value: "this_month", label: "This month" },
];

// capacity - booked_count; tolerates string numbers coming from the API
export const spotsLeft = (event) => {
  const capacity = parseInt(event && event.capacity, 10) || 0;
  const booked = parseInt(event && event.booked_count, 10) || 0;
  return capacity - booked;
};

// Sessions that are full are not displayed
export const hideFullEvents = (events = []) =>
  events.filter((event) => spotsLeft(event) > 0);

export const filterEventsBySearch = (events = [], term = "") => {
  const search = String(term || "").trim().toLowerCase();
  if (!search) return events;
  return events.filter((event) => {
    const languages = Array.isArray(event.languages)
      ? event.languages.join(" ")
      : event.languages;
    const haystack = [event.title, event.medium_name, event.description, languages]
      .filter(Boolean)
      .join(" ")
      .toLowerCase();
    return haystack.includes(search);
  });
};

export const filterEventsByDateRange = (events = [], range = "all", now = moment()) => {
  if (!range || range === "all") return events;
  const start = moment(now).startOf("day");
  const end =
    range === "this_month"
      ? moment(now).endOf("month")
      : moment(now).add(parseInt(range, 10) || 0, "days").endOf("day");
  return events.filter((event) => {
    const date = moment(event.date, "YYYY-MM-DD");
    return date.isValid() && date.isSameOrAfter(start) && date.isSameOrBefore(end);
  });
};

// Combined pipeline used by the listing page
export const applyEventFilters = ({ events = [], search = "", range = "all", now = moment() }) =>
  filterEventsByDateRange(filterEventsBySearch(hideFullEvents(events), search), range, now);
